import React, { useState } from 'react';
import Modal from '@material-ui/core/Modal';

function addPropsToReactElement(element, props) {
  if (React.isValidElement(element)) {
    return React.cloneElement(element, props);
  }
  return element;
}

function addPropsToChildren(children, props) {
  if (!Array.isArray(children)) {
    return addPropsToReactElement(children, props);
  }
  // If props needed in Multiple childrens react component as well
  // return children.map((childElement) =>
  //   addPropsToReactElement(childElement, props)
  // );
}

const MyAccordion = ({ trigger, component, children }) => {
  const [open, setOpen] = useState(false);
  const closeModal = () => {
    setOpen(false);
  };
  return (
    <>
      <div onClick={() => setOpen(true)}>{trigger}</div>
      {/* {open && ( */}
      <Modal open={open}>
        <div className='relative z-10' role='dialog'>
          <div className='fixed inset-0 backdrop-filter backdrop-blur-0 filter bg-gray-500 bg-opacity-75 transition-opacity' />

          <div className='fixed inset-0 z-10 overflow-y-auto'>
            <div
              onClick={() => setOpen(false)}
              className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className='transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all'
              >
                {addPropsToChildren(component || children, { closeModal })}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MyAccordion;

//* USAGE
// setOpen hooks available in  children or component passed as well
//* 1
// <MyAccordion
//   trigger={<DeleteIcon className='text-red-300 cursor-pointer' />}
//   component={<ConfirmDialog accept={handleDelete} />}
// />;
//! OR
//* 2
//  <MyAccordion
//    trigger={<DeleteIcon className='text-red-300 cursor-pointer' />}
//  >
//    <ConfirmDialog accept={handleDelete} />
//  </MyAccordion>;
